import { useEffect, useState } from 'react';
import {
  loadNhStyleFingerprintSnapshot,
  nhStyleFingerprintFixture,
} from '../utils/nhStyleFingerprintSnapshot';

/**
 * Reads the committed NH style fingerprint fixture.
 * Does not query Firestore or the beer collection.
 */
function useNhStyleFingerprintSnapshot() {
  const [snapshot, setSnapshot] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    Promise.resolve()
      .then(() => loadNhStyleFingerprintSnapshot(nhStyleFingerprintFixture))
      .then((result) => {
        if (cancelled) {
          return;
        }
        setSnapshot(result.snapshot);
        setError(result.error);
        setLoading(false);
      })
      .catch((loadError) => {
        console.error('useNhStyleFingerprintSnapshot', loadError);
        if (cancelled) {
          return;
        }
        setSnapshot(null);
        setError('Failed to load NH style fingerprints.');
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { snapshot, loading, error };
}

export default useNhStyleFingerprintSnapshot;
